export default spacing => {
  const boxSizing = `
    box-sizing: border-box;
    ::after, ::before {
      box-sizing: border-box;
    }
  `;

  // METHODS
  const styles = (property, prefix = '') => {
    const currentSpacing = 2;
    return `
        ${property}-left: ${prefix}${spacing(currentSpacing)}px;
        ${property}-right: ${prefix}${spacing(currentSpacing)}px;
    `;
  };

  return {
    gutters: styles('padding'),
    grid: styles('margin', '-'),
    boxSizing,
  };
};
